import React from 'react';
import { SalesPage } from './pages/SalesPage';
type AppProps = {
  showReviews?: boolean;
  showCountdown?: boolean;
  showExtrasOffer?: boolean;
  guaranteeEnabled?: boolean;
};
export function App({
  showReviews = false,
  showCountdown = false,
  showExtrasOffer = false,
  guaranteeEnabled = true
}: AppProps) {
  return <SalesPage showReviews={showReviews} showCountdown={showCountdown} showExtrasOffer={showExtrasOffer} guaranteeEnabled={guaranteeEnabled} data-id="element-0" data-mp="3fb173kr4obcy" />;
}